
import Layout from '../components/Layout';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const faqItems = [
    {
      question: "How do I add Fembot to my Discord server?",
      answer: "You can add Fembot to your server by clicking the 'Add to Discord' button on our homepage. You'll need to have the 'Manage Server' permission on the Discord server you want to add it to."
    },
    {
      question: "Is Fembot free to use?",
      answer: "Yes, Fembot offers a free Basic plan with essential features. For more advanced features, we offer Plus and Pro premium plans with additional capabilities."
    },
    {
      question: "How do I set up moderation on my server?",
      answer: "After adding Fembot a setup process will automatically be initialized. You can configure moderation settings, auto-mod rules, warning thresholds and much more through our guided setup or by using specific commands."
    },
    {
      question: "What are the AI capabilities of Fembot?",
      answer: "Fembot's AI can engage in conversations, answer questions, and provide smart responses. These features are available to Plus users (50 interactions per day) and Pro users (unlimited interactions)."
    },
    {
      question: "How do I report issues with Fembot?",
      answer: "You can report issues through our Support page or by creating a ticket in our Discord server. For premium users, we offer priority support through our dedicated support channels."
    },
    {
      question: "Can I customize Fembot's responses?",
      answer: "Yes, premium users can customize certain responses and interaction behavior. Pro users have access to more extensive customization options."
    },
    {
      question: "What security features does Fembot provide?",
      answer: "Fembot includes raid protection, verification systems, spam detection, anti-phishing measures, role security, and security audits. Enhanced security tools are available with premium plans."
    },
    {
      question: "How do I cancel my premium subscription?",
      answer: "You can cancel your subscription at any time from your account settings page. Your premium features will remain active until the end of your current billing period."
    },
    {
      question: "Does Fembot collect data from my server?",
      answer: "Fembot collects minimal necessary data to function properly. This includes command usage, server IDs, and channel IDs. We do not store message content except when explicitly required for features like custom commands. Please see our Privacy Policy for full details."
    },
    {
      question: "Can multiple people use Fembot's admin commands?",
      answer: "Yes, anyone with the appropriate Discord permissions or roles set up in Fembot's configuration can use admin commands."
    }
  ];

  return (
    <Layout>
      <div className="py-24 bg-gradient-to-b from-white to-pink-50 dark:from-gray-800 dark:to-gray-900">
        <div className="container-custom">
          <div className="text-center mb-16">
            <div className="inline-block p-3 rounded-full bg-fembot-pink/10 mb-4">
              <HelpCircle className="h-10 w-10 text-fembot-pink" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 dark:text-white">
              Frequently Asked <span className="text-fembot-pink">Questions</span>
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Find answers to common questions about Fembot and its features
            </p>
          </div>

          <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 md:p-8">
            <Accordion type="single" collapsible className="w-full">
              {faqItems.map((item, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left font-semibold text-lg dark:text-white">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 dark:text-gray-300">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
              Can't find the answer you're looking for? Visit our <a href="/support" className="text-fembot-pink hover:underline">Support page</a> for more help.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FAQ;
